@for (element of info(); track element) {
  @if (element | dateEval) {
    <p-message
      [severity]="typeToSeverityMap[element.type]"
      styleClass="mt-3 w-100"
    >
      <div class="d-flex flex-row justify-content-start gap-2">
        <span
          class="material-symbols-outlined"
          [ngClass]="{ h4: element.title }"
          >{{ typeToIconMap[element.type] }}</span
        >
        <div>
          @if (element.title) {
            @if (language === 'de') {
              <h4>{{ element.title.de }}</h4>
            } @else {
              <h4>{{ element.title.en }}</h4>
            }
          }
          @if (language === 'de') {
            <p [innerHTML]="element.text.de"></p>
          } @else {
            <p [innerHTML]="element.text.en"></p>
          }
        </div>
      </div>
    </p-message>
  }
}
